import reducer from './reducers';

export { default as incidentOperations } from './operations';
export { default as incidentTypes } from './types';

export default reducer;
